import React from 'react';
import ComponentsFactory from 'foundation/components-factory';
import gtm from 'general/js/gtm';

class CustomEventLeaderboardInfoButton extends React.Component {
    constructor(props) {
        super(props);

        this.rootRef = React.createRef();
    }

    componentDidMount() {
        ComponentsFactory.getInstance().init(this.rootRef.current);
    }

    componentWillUnmount() {
        ComponentsFactory.getInstance().destroy(this.rootRef.current);
    }

    onClick = () => {
        gtm.push('Leaderboard - Heroes Classic', 'Information', 'Select Information');
    }

    render() {
        return (
            <a
                className="button-round button-round--base is-border-white"
                href="/popup-pages/custom-event-leaderboard-information"
                ref={this.rootRef}
                data-dc-component="modal-trigger"
                onClick={this.onClick}
            >
                <svg className="icon custom-event-leaderboard__info-button-icon"
                    width="18" height="18" focusable="false">
                    <use xlinkHref="#icon-i"></use>
                </svg>
            </a>
        );
    }
}

export default CustomEventLeaderboardInfoButton;
